import { render, staticRenderFns } from "./GameDiplomacyPeaceDeclared.vue?vue&type=template&id=46eac86a&scoped=true&"
import script from "./GameDiplomacyPeaceDeclared.vue?vue&type=script&lang=js&"
export * from "./GameDiplomacyPeaceDeclared.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46eac86a",
  null
  
)

export default component.exports